export default __webpack_public_path__ + "static/media/metallic-prints-hanger.53b17eb4.jpg";